<script setup lang="ts">
import { computed } from 'vue'

import { Selector } from '../../'
import { FILTER_OPERATOR_OPTIONS } from '../../../constants'
import type { FilterOperatorEnum } from '../../../types'

defineProps<{ size?: 'default' | 'large'; isDisabled?: boolean }>()

const operator = defineModel<FilterOperatorEnum | null>({ default: null })

const selectedOption = computed(() => FILTER_OPERATOR_OPTIONS.find((option) => option.value === operator.value) ?? null)

const handleSelection = (item: { id: number; label?: string } | null) => {
  if (!item) {
    operator.value = null
    return
  }
  const selected = FILTER_OPERATOR_OPTIONS.find((option) => option.id === item.id)
  operator.value = selected?.value ?? null
}
</script>

<template>
  <Selector
    :options="FILTER_OPERATOR_OPTIONS"
    :selected-option="selectedOption"
    :selected-label="selectedOption?.label ?? 'Operator'"
    should-truncate-text
    :truncate-option-text="false"
    :show-search="false"
    :size="size"
    :is-disabled="isDisabled"
    placeholder="Operator"
    @update:selected-option="handleSelection"
  />
</template>
